<template>
  <v-container fluid class="pa-0 pb-8">
    <v-container class="container-custom" v-if="!updateDiscountCouponStatus">
      <Breadcrumbs :title="$t('modules.discountCoupons.update.breadcrumbs.title')"
        :description="$t('modules.discountCoupons.update.breadcrumbs.description')"></Breadcrumbs>
      <v-row justify="center">
        <v-col class="viewSpaces" sm="12">
          <OutlinedCard
          :title="$t('modules.discountCoupons.update.codeSection.title')"
          :subtitle="$t('modules.discountCoupons.update.codeSection.subtitle')"
          :switch-label="(status) ? $t('enabled') : $t('disabled')"
          :switch-value="status"
          @switchChange="(val) => { this.status = val }"
          switcher class="mb-6"
          >
            <v-row>
              <v-col sm="6">
                <v-text-field
                :error-messages="getErrorMessagesByFields($v.description, errorMessagesFields.description)"
                @blur="$v.description.$touch()"
                @keypress="$validateAlphanumeric($event, $v.description.$model, 60, true)"
                v-model="$v.description.$model"
                ref="description"
                :label="`${$t('modules.discountCoupons.update.codeSection.labels.name')} *`"
                outlined
                />
              </v-col>
              <v-col sm="3">
                <v-text-field
                :error-messages="getErrorMessagesByFields($v.code, errorMessagesFields.code)"
                @keypress="$validateAlphanumeric($event, $v.code.$model, 16)"
                :loading="loadingCode"
                v-model="$v.code.$model"
                ref="code"
                :label="`${$t('modules.discountCoupons.update.codeSection.labels.code')} *`"
                outlined
                disabled
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="3">
                <v-text-field
                v-model="maxUsagesPerUser"
                :error-messages="getErrorMessagesByFields($v.maxUsagesPerUser, errorMessagesFields.maxUsagesPerUser)"
                outlined
                min="1"
                max="9999"
                label="Usos por usuario"
                ref="maxUsagesPerUser"
                @keypress="$validateIntegerInputNumber($event, $v.maxUsagesPerUser.$model, null, null,1)"
                @blur="$v.maxUsagesPerUser.$touch()"
                />
              </v-col>
              <v-col sm="3">
                <v-menu
                ref="menuFrom"
                v-model="menuFrom"
                :close-on-content-click="false"
                transition="scale-transition"
                :return-value.sync="dateFrom"
                offset-y
                bottom
                max-width="290px"
                min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="dateFrom"
                    :label="`${$t('modules.discountCoupons.create.codeSection.labels.dateFrom')} *`"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    v-on="on"
                    :error-messages="getErrorMessagesByFields($v.dateFrom, errorMessagesFields.dateFrom)"
                    @blur="$v.dateFrom.$touch()"
                    disabled
                    />
                  </template>
                  <v-date-picker
                  v-model="dateFrom"
                  no-title
                  color="primary"
                  scrollable
                  @change="changeDateFrom"
                  :min="(() => (new Date().toISOString().substr(0, 10)))()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuFrom = false">{{ $t('actions.cancel') }}</v-btn>
                    <v-btn text color="primary" @click="$refs?.menuFrom.save(dateFrom)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="3">
                <v-menu
                ref="menuTo"
                v-model="menuTo"
                :close-on-content-click="false"
                :return-value.sync="dateTo"
                transition="scale-transition"
                offset-y
                bottom min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="dateTo"
                    :label="`${$t('modules.discountCoupons.create.codeSection.labels.dateTo')}`"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    v-on="on"
                    @blur="$v.dateTo.$touch()"
                    disabled
                    />
                  </template>
                  <v-date-picker
                  v-model="dateTo"
                  no-title
                  color="primary"
                  scrollable
                  :min="minDateTo"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuTo = false">{{ $t('actions.cancel') }}</v-btn>
                    <v-btn text color="primary" @click="$refs.menuTo.save(dateTo)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="4" class="pb-0">
                <v-select
                v-model="discountType"
                :label="`${$t('modules.discounts.create.section_zone.items.discountType')}`"
                :items="listDiscountTypesFields"
                outlined class="no-message"
                @change="$v.discountValue.$reset(); discountValue = null;$v.maxDiscount.$reset(); maxDiscount = null"
                />
              </v-col>
              <v-col sm="4">
                <v-text-field
                v-model="discountValue"
                @blur="$v.discountValue.$touch()"
                ref="discountValue"
                :error-messages="getErrorMessagesByFields($v.discountValue, errorMessagesFields.discountValue)"
                v-bind="discountValueField.attributes"
                v-on="discountValueField.events"
                outlined
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="4">
                <v-text-field
                :error-messages="getErrorMessagesByFields($v.minPayment ,errorMessagesFields.minPayment)"
                type="number"
                v-model.number="minPayment"
                ref="minPayment"
                :label="$t('modules.discountCoupons.create.sectionCondition.labels.minPayment')"
                prepend-inner-icon="mdi-currency-usd"
                @keypress="$validateIntegerInputNumber($event, $v.minPayment.$model, null, null, 0)"
                @blur="$v.minPayment.$touch()"
                outlined
                />
              </v-col>
              <v-col sm="4">
                <v-text-field v-if="discountType !== 'amount'"
                :error-messages="getErrorMessagesByFields($v.maxDiscount, errorMessagesFields.maxDiscount)"
                v-model.number="maxDiscount"
                ref="maxDiscount"
                @keypress="$validateIntegerInputNumber($event, $v.maxDiscount.$model, null, null, 1)"
                @blur="$v.maxDiscount.$touch()" type="number"
                prepend-inner-icon="mdi-currency-usd"
                :label="$t('modules.discountCoupons.create.sectionCondition.labels.maxDiscount')"
                outlined
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6">
                <v-switch
                dense
                v-model="manualAssignation"
                :label="$t('modules.discountCoupons.create.codeSection.labels.manualAssignation')"
                />
              </v-col>
            </v-row>
          </OutlinedCard>
          <OutlinedCard
            :title="$t('modules.discountCoupons.create.products.title')"
            :subtitle="$t('modules.discountCoupons.create.products.subtitle')"
            class="mb-6"
            >
            <v-row>
              <v-col sm="7">
                <v-select
                  :label="`${$t('modules.discountCoupons.create.products.items.product')} *`"
                  item-text="name"
                  :items="products"
                  outlined
                  return-object
                  v-model="$v.selectedBillingProduct.$model"
                  ref="selectedBillingProduct"
                  :error-messages="($v.selectedBillingProduct.$dirty && $v.selectedBillingProduct.$invalid) ?
                  $t('modules.discountCoupons.validations.productRequired') : ''"
                  @blur="$v.selectedBillingProduct.$touch()"
                ></v-select>
              </v-col>
            </v-row>
          </OutlinedCard>
          <OutlinedCard :title="$t('modules.discountCoupons.create.sectionRestriction.title')" class="mb-6">
                <v-radio-group v-model="limited" class="no-message ma-0" @change="$v.limit.$reset()">
                  <v-row>
                    <v-col>
                      <v-radio
                        :label="$t('modules.discountCoupons.create.sectionRestriction.labels.radioFirst')"
                        color="primary"
                        :value="0"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col align-self="center">
                      <v-radio
                      :label="$t('modules.discountCoupons.create.sectionRestriction.labels.radioSecond')"
                      color="primary"
                      :value="1"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                      :error-messages="getErrorMessagesByFields($v.limit, errorMessagesFields.limit)"
                      outlined
                      v-model.number="$v.limit.$model"
                      ref="limit"
                      type="number"
                      min="1"
                      @keypress="$validateIntegerInputNumber($event, $v.limit.$model, null, 6)"
                      @blur="$v.limit.$touch()"
                      :disabled="!limited"
                      />
                    </v-col>
                  </v-row>
                </v-radio-group>
              </OutlinedCard>
          <OutlinedCard :title="$t('modules.discountCoupons.create.studentSection.title')" class="mb-6">
           <v-row>
            <v-col sm="4" v-for="(studentType, index) in studentTypes" :key="index">
              <v-checkbox
              v-model="selectedStudentType"
              ref="selectedStudentType"
              color="primary"
              :label="studentType.meaning"
              :value="studentType.value"
              @change="$v.selectedStudentType.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-alert text type="error" v-if="$v.selectedStudentType.$anyError">
                {{ getErrorMessagesByFields($v.selectedStudentType, errorMessagesFields.selectedStudentType) }}
              </v-alert>
            </v-col>
          </v-row>
          </OutlinedCard>
          <OutlinedCard
          :title="$t('modules.discountCoupons.create.termSection.title')"
          :subtitle="$t('modules.discountCoupons.create.termSection.subtitle')"
          class="mb-6"
          >
            <TransferList
            :firstListTitle="$t('modules.discountCoupons.create.termSection.transferList.firstTitle')"
            :secondListTitle="$t('modules.discountCoupons.create.termSection.transferList.secondTitle')"
            :availableItems.sync="terms"
            :added-items.sync="$v.termsAdded.$model"
            ref="termsAdded"
            />
            <v-alert
            v-if="$v.termsAdded.$dirty && $v.termsAdded.$anyError"
            text type="error"
            class="mt-4"
            >
              {{ $t('modules.discountCoupons.validations.noSelectedTerms') }}
            </v-alert>
          </OutlinedCard>
          <OutlinedCard
          :title="$t('modules.discountCoupons.create.zoneSection.title')"
          class="mb-6"
          >
            <v-checkbox
            :key="index"
            :label="zone.zoneDescription"
            :value="zone.id"
            class="mr-8 mt-0 no-message"
            color="primary"
            ref="selectedZone"
            v-for="(zone, index) in zones"
            v-model="$v.selectedZone.$model"
            />
            <v-alert text type="error" v-if="$v.selectedZone.$anyError">
              {{ $t('modules.discountCoupons.validations.zone') }}
            </v-alert>
          </OutlinedCard>
          <OutlinedCard
          :title="$t('modules.discountCoupons.create.careersSection.title')"
          :subtitle="$t('modules.discountCoupons.create.careersSection.subtitle')"
          class="mb-6"
          >
            <TransferList
            :firstListTitle="$t('modules.discountCoupons.create.careersSection.transferList.firstTitle')"
            :secondListTitle="$t('modules.discountCoupons.create.careersSection.transferList.secondTitle')"
            :addedItems.sync="$v.selectedCareers.$model"
            :availableItems.sync="availableCareers"
            ref="selectedCareers"
            />
            <v-alert text type="error" class="mt-4" v-if="$v.selectedCareers.$dirty && $v.selectedCareers.$anyError">
              {{ $t('modules.discountCoupons.validations.noSelectedCareers') }}
            </v-alert>
          </OutlinedCard>
          <div class="d-flex justify-end">
            <Button
            white
            :text="$t('actions.cancel')"
            @clicked="$router.replace('/coupons')"
            @end="resetButtonValues"
            class="mr-4"
            />
            <Button
            :loading="createButton.loading"
            :success="createButton.success"
            :error="createButton.error"
              :text="$t('actions.save')"
              :successText="$t('actions.saved')"
              :errorText="$t('actions.error')"
              :disabled="!canUpdate"
              @end="resetButtonValues"
              @clicked="updateDiscountCoupon"
              />
          </div>
        </v-col>
      </v-row>
    </v-container>
    <SuccessMessage
    v-else
    :type="successMessage.type"
    :title="successMessage.title"
    :actionPrimary="successMessage.actionPrimary"
    :actionSecondary="successMessage.actionSecondary"
    />
  </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
import Button from '@/components/Button/Button';
import SuccessMessage from '@/components/SuccessMessage/SuccessMessage';
import TransferList from '@/components/TransferList/TransferListNew';
import {required, alphaNum,minValue , requiredIf,minLength, maxLength, helpers} from 'vuelidate/lib/validators';

import { $discountCoupons, $types, $terms, $careers, $zones, $products } from '../Services';
import moment from 'moment'

export default {
  name: 'DiscountCouponsCreate',
  components: {
    Breadcrumbs,
    OutlinedCard,
    Button,
    SuccessMessage,
    TransferList,
  },
  data() {
    return {
      description: '',
      code: null,
      maxUsagesPerUser: 1,
      discountType: 'percentage',
      listDiscountTypesFields: [
        {
          text: this.$t('modules.discountCoupons.create.codeSection.labels.amountDiscount'),
          value: 'amount'
        },
        {
          text: this.$t('modules.discountCoupons.create.codeSection.labels.percentageDiscount'),
          value: 'percentage'
        }
      ],
      errorMessagesFields:{
        description:{
          required: this.$t('modules.discountCoupons.validations.nameRequired'),
          alphaNumWithSpaces: this.$t('modules.discountCoupons.validations.nameAlphanumericWithSpaces'),
          maxLength: this.$t('modules.discountCoupons.validations.nameMaxLength')
        },
        code:{
          required:this.$t('modules.discountCoupons.validations.nameRequired'),
          alphaNum: this.$t('modules.discountCoupons.validations.codeAlphanumeric'),
          length: this.$t('modules.discountCoupons.validations.codeMaxLength'),
          unique: this.$t('modules.discountCoupons.validations.codeUnique')
        },
        maxUsagesPerUser:{
          required:  this.$t('modules.discountCoupons.validations.maxUsagesPerUserRequired')
        },
        dateFrom:{
          required: this.$t('modules.discountCoupons.validations.dateFromRequired')
        },
        dateTo:{
          required: this.$t('modules.discountCoupons.validations.dateToRequired')
        },
        discountValue:{
          requiredPercentage: this.$t('modules.discountCoupons.validations.percentageRequired'),
          requiredAmount: this.$t('modules.discountCoupons.validations.amountRequired'),
          validPercentage:  this.$t('modules.discountCoupons.validations.percentageBetweenValues'),
          validAmount: this.$t('modules.discountCoupons.validations.amount')
        },
        minPayment:{
          validAmount: this.$t('modules.discountCoupons.validations.amount'),
          amountMustBeGreaterThanMinPayment: this.$t('modules.discountCoupons.validations.amountMustBeGreaterThanMinPayment')
        },
        maxDiscount:{
          validAmount: this.$t('modules.discountCoupons.validations.amount')
        },
        limit: {
          minValue: this.$t('modules.discountCoupons.validations.limitMinValue'),
          required: this.$t('modules.discountCoupons.validations.limitRequired')
        },
        selectedStudentType:{
          required: this.$t('modules.discountCoupons.validations.selectedStudentTypeRequired')
        },
        selectedBillingProduct: { required },
      },
      discountValue: null,
      manualAssignation: false,
      minPayment: 0,
      maxDiscount: null,
      limit: 1,
      limited: 0,
      studentTypes: [],
      selectedStudentType: [7],
      zones: [],
      selectedZone: [],
      availableCareers: [],
      selectedCareers: [],
      terms: [],
      termsAdded: [],
      loadingCode: false,
      status: false,
      updateDiscountCouponStatus: false,
      dateFrom: null,
      dateTo: null,
      menuFrom: false,
      menuTo: false,
      createButton: {
        loading: false,
        success: false,
        error: false
      },
      successMessage: {
        type: null,
        title: null,
        actionPrimary: null,
        actionSecondary: null
      },
      products: [],
      selectedBillingProduct: null
    };
  },
  computed: {
    canUpdate() {
      return this.$permissions.portaladministrativo.prices.extraBenefits.UPDATE;
    },
    discountValueField() {
      const props = {
          amount: {
            attributes: {
              type:'number',
              'prepend-inner-icon': 'mdi-currency-usd',
            },
            events: {
              keypress: (event)=> this.$validateIntegerInputNumber(event, this.discountValue, null, null, 1)
            }
          },
          percentage: {
            attributes: {
              type: 'text',
              'append-icon': 'mdi-percent',
            },
            events: {
              // eslint-disable-next-line
              keypress: (event)=> {
                const {target, key} = event
                const value = target.value + key
                const regex = /^(0(\.(0?[1-9]|[1-9]\d?|\d?))?|[1-9]\d?(\.\d{1,2})?|[1-9]\d?(\.)?|100)$/
                if(!regex.test(value)){
                  event.preventDefault()
                }
              }
            }
          }
        }
      return { ...props[this.discountType]}
    },
    minDateTo(){
      return this.dateFrom
    ? moment(this.dateFrom).format('YYYY-MM-DD')
    : moment().format('YYYY-MM-DD')
    }
  },
  async created() {
    if(!this.$route.params.id) this.$router.push('/coupons')
    await Promise.allSettled([
      this.getStudentType(),
      this.getTerms(),
      this.getZones(),
      this.getCareers(),
      this.getProducts()
    ])
    this.getDiscountCouponById(this.$route.params.id)
  },
  methods: {
    async getProducts() {
      try {
        const { data } = await $products.find();
        this.products = data.content;
      } catch (error) {
        this.products = [];
      }
    },
    changeDateFrom(date){
      if(moment(this.dateTo).isValid&&moment(date).isAfter(this.dateTo)){
        this.dateTo = null
      }
    },
    getErrorMessagesByFields(validation, messages){
      try {
      const errorMessage = Object.keys(validation.$params)
        .map(key=> !validation[key] ? messages[key] : null)
        .filter(message=> !!message)
        .at(0)
      return (validation.$invalid && validation.$dirty) ? errorMessage : ''
      } catch {
        return ''
      }

    },
    async getTerms() {
      try {
        const { data } = await $terms.find(null, null, {
          params: {
            page: 0,
            length: 100,
            orderBy: 'classStartDate',
            orientation: 'desc',
          }
        });

        this.terms = data.content
          .filter(item => item.termType?.value === 193 || item.termType?.value === 482)
          .map(item => {
            item.name = `(${item.code}) ${item.description}`;
            return item;
          });
      } catch (error) {
        this.terms = [];
        throw error;
      }
    },
    async getCareers() {
      try {
        const { data } = await $careers.find(null, null, {
          params: {
            page: 0,
            length: 100,
            orderBy: 'id',
            orientation: 'desc',
            excludeStudyPlan: true
          }
        });
        this.availableCareers = data.content.map(item => {
          item.name = `(${item.code}) ${item.description}`;
          return item;
        });
      } catch (err) {
        this.availableCareers = [];
        throw err;
      }
    },
    async getZones() {
      try {
        const { data } = await $zones.find(null, null, {
          params: {
            page: 0,
            length: 100,
            orderBy: 'id',
            orientation: 'desc'
          }
        });
        this.zones = data.content;
      } catch (err) {
        this.zones = [];
        throw err;
      }
    },
    async getStudentType() {
      try {
        const { data } = await $types.find(null, null, { params: { type: 'STUDENT_TYPE' } });
        this.studentTypes = data;
      } catch (err) {
        this.studentTypes = [];
        throw err;
      }
    },
    async getDiscountCouponById(id){
      const { data } = await $discountCoupons.findById(id)
        this.description = data.name || ''
        this.status = data.status
        this.code = data.code
        this.dateFrom = data.dateFrom
        this.dateTo = moment(data.dateTo).isValid() ?  data.dateTo : null
        this.minPayment = data.minPayment
        this.maxDiscount = data.maxDiscount
        this.maxUsagesPerUser = data.maxUsagesPerUser
        this.manualAssignation = data.manualAssignation
        if(data.billingProductId) {
          this.selectedBillingProduct = this.products.find(product => product.id === data.billingProductId)
        }
        if(!isNaN(data.percentageDiscount) && Number(data.percentageDiscount) > 0){
          const { value } = this.listDiscountTypesFields.find(type=> type.value === 'percentage')
          this.discountType = value
          this.discountValue = parseFloat(data.percentageDiscount).toFixed(2)
        }else if(!isNaN(data.ammountDiscount)){
          const { value } = this.listDiscountTypesFields.find(type=> type.value === 'amount')
          this.discountType = value
          this.discountValue = data.ammountDiscount
        }

        if(data.maxUsers){
          this.limited = 1
          this.limit = data.maxUsers
        }

        if(Array.isArray(data.studentType) && data.studentType.length){
          this.selectedStudentType = data.studentType.map(({ value })=> value)
        }

        if(Array.isArray(data.zones) && data.zones.length){
          this.selectedZone = data.zones.map(({ id })=> id)
        }

        if(Array.isArray(data.terms) && data.terms.length){
          const termsIds = data.terms.map(({ id })=> id)
          this.termsAdded = this.terms.filter(term=> termsIds.includes(term.id))
        }

      if(Array.isArray(data.careers) && data.careers.length){
        const careersIds = data.careers.map(({ id })=> id)
        this.selectedCareers = this.availableCareers.filter(career=> careersIds.includes(career.id))
      }
    },
    async updateDiscountCoupon() {
      this.createButton.loading = true;
      try {
        if (this.$v.$invalid) {
          if (this.$v.$invalid) {
            this.$v.$touch();
            Object.keys(this.$v).some(input => {
                if (input.includes('$')) return false;
                if (this.$v[input].$error) {
                  this.$refs[input][0]
                    ? this.$refs[input][0].$el.scrollIntoView({ block: 'center', behavior: 'smooth' })
                    : this.$refs[input].$el.scrollIntoView({ block: 'center', behavior: 'smooth' });
                  return true
                }
              })
            this.createButton.error = true;
            this.createButton.loading = false;
          }
        } else {
          const { id } = this.$route.params
          const studentType = this.studentTypes
            .filter(studentType => this.selectedStudentType.includes(studentType.value))
          const terms = this.termsAdded.map(({ id, code, description }) => ({ id, code, description }))
          const careers = this.selectedCareers.map(({ id, code, description }) => ({ id, code, description }))
          const zones = this.zones
            .filter(zone => this.selectedZone.includes(zone.id))
            .map(({ id, zoneDescription }) => ({ id, description: zoneDescription }))

          const data = {
            id,
            name: this.description.trim(),
            code: this.code,
            status: this.status,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            minPayment: this.minPayment,
            maxDiscount: this.maxDiscount,
            ammountDiscount: this.discountType === 'amount' ? this.discountValue : null,
            percentageDiscount: this.discountType === 'percentage' ? Number(parseFloat(this.discountValue ).toFixed(2)): null,
            maxUsagesPerUser: this.maxUsagesPerUser,
            manualAssignation: this.manualAssignation,
            maxUsers: this.limited ? this.limit : null,
            studentType,
            terms,
            careers,
            zones,
            billingProductId: this.selectedBillingProduct?.id
          }
          await $discountCoupons.update(id, data);
          this.successMessage.type = 'success';
          this.successMessage.title = this.$t('modules.discountCoupons.update.successMessage.title');
          this.successMessage.actionPrimary = {
            text: this.$t('actions.accept'), callback: () => {
              this.$router.push('/coupons');
            }
          };
          this.updateDiscountCouponStatus = true;
          this.createButton.success = true;
          this.createButton.loading = false;
          this.clearData();
        }
      } catch (error) {
        this.successMessage.type = 'error';
        this.successMessage.title = (error.codeMeaning != '') ? error.codeMeaning : this.$t('modules.discountCoupons.update.errorMessage.title');
        this.successMessage.actionPrimary = {
          text: this.$t('actions.return'), callback: () => {
            this.updateDiscountCouponStatus = false;
          }
        };
        this.successMessage.actionSecondary = null;
        this.updateDiscountCouponStatus = true;
        this.createButton.loading = false;
        this.createButton.error = true;
        throw error;
      }
    },
    clearData() {
      this.resetButtonValues();
      this.description = null;
      this.code = null;
      this.status = true;
      this.termsAdded = [];
      this.selectedStudentType = 7;
      this.selectedZone = [];
      this.selectedCareers = [];
      this.$v.$reset();
    },
    resetButtonValues() {
      this.createButton.loading = false;
      this.createButton.success = false;
      this.createButton.error = false;
    },
  },
  validations(){
    const validations = {
      description: {
        required,
        maxLength: maxLength(60),
        alphaNumWithSpaces: helpers.regex('withSpace', /^[a-z0-9]+(?:[a-z0-9]+\s[a-z0-9]*)*$/i)
      },
      code: {
        required,
        alphaNum,
        minLength: minLength(5),
        maxLength: maxLength(16),
      },
      selectedBillingProduct: { required },
      maxUsagesPerUser: { required },
      discountValue: { },
      minPayment: {
        validAmount: (value) => !isNaN(value) && Number(value) >= 0
      },
      maxDiscount: {
        validAmount(value){
          if(!value) return true
          return !isNaN(value) && Number(value) > 0
        }
      },
      limit: {
        minValue: minValue(1),
        required: requiredIf(function () {
          return this.limited
        })
      },
      selectedStudentType: { required },
      termsAdded: { required },
      dateFrom: { required },
      dateTo: {},
      selectedZone: { required },
      selectedCareers: { required },
    }

    if(this.discountType === 'percentage') {
      validations.discountValue = {
        ...validations.discountValue,
        requiredPercentage: required,
        validPercentage(value) {
          const integerRgx = /^(0|[1-9][0-9]?|100)$/
          const floatRgx = /^(?!0(\.00)?$)(?!00(\.00)?$)(?!0(\.[0]{2})?$)(\d{1,2})(\.\d{2})?$/
          if(integerRgx.test(value)){
            return Number(value) > 0 && Number(value) <= 100
          }else{
            return floatRgx.test(value)
          }
        }
      }
    }else if(this.discountType === 'amount'){
      validations.discountValue = {
        ...validations.discountValue,
        requiredAmount: required,
        validAmount(value){
          return !isNaN(value) && Number(value) > 0
        }
      }
      validations.minPayment = {
        ...validations.minPayment,
        amountMustBeGreaterThanMinPayment(value){
          try {
            if(this.discountValue && value){
              if(!(Number(value) > Number(this.discountValue))){
                throw null
              }
            }
            return true
          } catch {
            return false
          }
        }
      }
    }

    return validations
  }
};
</script>
